import { useJsApiLoader } from '@react-google-maps/api';
import { MAP_LIBRARIES } from '../utils/AppUtils';

export const useGoogleMapsLoader = () => {
    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_API_KEY!,
        libraries: MAP_LIBRARIES,
        version: '3',
        language: 'EN',
    });

    return { isLoaded };
};
